import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-add-authority',
  templateUrl: './add-authority.component.html',
  styleUrls: ['./add-authority.component.scss'],
})
export class AddAuthorityComponent implements OnInit {
  authorityForm!: FormGroup;
  authorities: any[] = [];
  buttonColorName: any;
  allListingEmployee: any = []
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserName: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  editAuthorityData: any;
  mainComponentData: any;
  selectUserId: any;
  constructor(
    public sharedService: SharedService,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,private toastr: ToastrService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    public dialogRef: MatDialogRef<AddAuthorityComponent>,
    @Inject(MAT_DIALOG_DATA) public autoritydata: any,
    private cdRef: ChangeDetectorRef
  ) {


    this.mainComponentData = autoritydata;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.authorityForm = this.fb.group({
      employeeId: ['', Validators.required],
      isActive: [true],
      allocatingDep: ['', Validators.required],
      assetAuthorityId: []
    });

    this.editAuthorityData = this.mainComponentData.operation == 'Add';
    this.mainComponentData.data != null ? this.editAuthorityData == true : this.editAuthorityData == false

    if (this.mainComponentData?.data != null) {
      this.selectUserId = this.mainComponentData.data.userId;

      this.authorityForm.patchValue({
        employeeId: this.selectUserId,
        isActive: true, // Assuming it's active by default
        allocatingDep: this.mainComponentData.data.assetDepartmentName,
        employeeName: this.mainComponentData.data.employeeName,
        assetAuthorityId: this.mainComponentData.data.assetAuthorityId
      });
    }
  }
  ngOnInit() {


    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getAllAssetManagementApi();
 
  }

  hasError(controlName: any, errorType: any) {
    const control = this.authorityForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  getAllAssetManagementApi() {
    this.getEmployee()
  }


  // getEmployee() {

  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "userId": this.loggedInUserId
  //   };
  //   this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
  //     console.log(data);

  //     // this.allListingEmployee = data.data;
  //     this.allListingEmployee = data.data.filter((emp: any) => emp.dateOfJoining !== null);
  //     console.log("LoggedInUserROle",this.loggedInUserRole);

  //   })
  // }



  getEmployee() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      userId: this.loggedInUserId
    };

    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      console.log(data);

      //  Filter employees with non-null dateOfJoining
      this.allListingEmployee = data.data.filter((emp: any) => emp.dateOfJoining !== null);

      console.log("LoggedInUserROle", this.loggedInUserRole);
      console.log("LoggedInUserROles........", this.loggedInUserRoles);

      //   Exclude names only if HR Admin or Super Admin
      const role = this.loggedInUserRole?.toLowerCase();

      if (role === 'hr admin' || role === 'super admin') {
        const loggedInUserFullName = (this.loggedInUserName || '').trim().toLowerCase();
        const superAdminFullName = 'super admin';

        this.allListingEmployee = this.allListingEmployee.filter((emp: any) => {
          const empFullName = ((emp.firstName || '') + ' ' + (emp.lastName || '')).trim().toLowerCase();
          return empFullName !== loggedInUserFullName && empFullName !== superAdminFullName;
        });
      }

      // if Super Admin is logged in, exclude HR Admins
      if (role === 'super admin') {
        this.allListingEmployee = this.allListingEmployee.filter((emp: any) => {
          // HR Admin — replace with your actual role ID for HR Admin
          return !(emp.roles && emp.roles.includes(2));
        });
      }
      const isSuperAdmin = this.loggedInUserRoles?.some((r: any) => r.name === 'Super Admin');
      const hrAdminRoleId = 4;
  
      if (isSuperAdmin) {
        this.allListingEmployee = this.allListingEmployee.filter((emp: any) => {
          return !(emp.roles && emp.roles.includes(hrAdminRoleId));
        });
      }
  
      console.log("Final filtered employees >>>", this.allListingEmployee);
    });
  }



  onSubmit() {

    if(this.authorityForm.value.allocatingDep == '' && this.authorityForm.value.employeeId == ''){
      this.toastr.error('Please select both department and employee.', 'Error');
      return;
    }else if(this.authorityForm.value.allocatingDep == '' ){
      this.toastr.error('Please select department.', 'Error');
      return;
    }else if(this.authorityForm.value.employeeId == '' ){
      this.toastr.error('Please select employee.', 'Error');
      return;
    }

     
    let postData = this.authorityForm.value;
    postData.allocatingDep = postData.allocatingDep?.trim?.() || postData.allocatingDep;
    postData.employeeId = postData.employeeId?.trim?.() || postData.employeeId;
    const formData = {
      "assetDepartmentName": postData.allocatingDep,
      "userId": postData.employeeId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.mainComponentData.year,
      "fiscalYear": this.mainComponentData.fiscal_year
    };

    const autorityListData = this.mainComponentData?.autorityListData;

    if (autorityListData?.length > 0) {
      const isDuplicate = autorityListData.some((empData: any) =>
        // empData.userId === postData.employeeId && empData.assetDepartmentName === postData.allocatingDep,
        empData.userId?.toLowerCase?.() === postData.employeeId?.toLowerCase?.() &&
        empData.assetDepartmentName?.toLowerCase?.() === postData.allocatingDep?.toLowerCase?.()

      );

      if (isDuplicate) {
        this.toastr.error('Duplicate entry not allowed', 'Error');
        return; // Prevent further processing
      }
    }


    this.httpService.callPostService(this.config.addAssetAuthority, formData).subscribe(
      (data: any) => {
        if (data) {
          // Success popup
          this.toastr.success(data.message, 'Success');
           this.dialogRef.close();
        }
      },
      (error: any) => {
        this.toastr.error(error.error.message || 'Duplicate entry not allowed','error');
      }
    );
  }


  // updateAutority() {
  //     let updateData = this.authorityForm.value;

  //     const formData = {
  //       "assetDepartmentName": updateData.allocatingDep,
  //       "userId": updateData.employeeId,
  //       "companyId": this.loggedInUserCompanyID,

  //     };
  //     this.httpService.callPutService(`${this.config.updateAssetAuthority}/${updateData.assetAuthorityId}`, formData).subscribe(
  //       (data: any) => {


  //         if (data) {
  //           // Success popup
  //           const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //             disableClose: true,
  //             height: '25%',
  //             width: '30%',
  //             data: {
  //               msg: data.message,
  //               btn2: 'OK',
  //               btn2BgColor: this.buttonColorName,
  //               showSuccessIcon: true,
  //               showSuccessMessage: false,
  //               showCloseIcon: false
  //             }
  //           });

  //           // Handle the result of the dialog
  //           dialogRef.afterClosed().subscribe(() => {
  //             this.dialogRef.close();
  //           });
  //         }
  //       },
  //       (error: any) => {


  //         const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //           disableClose: true,
  //           height: '25%',
  //           width: '30%',
  //           data: {
  //             msg: error.error.error|| 'Duplicate entry not allowed',
  //             btn2: 'OK',
  //             btn2BgColor: 'red', // Highlight error with red button color
  //             showSuccessIcon: false,
  //             showSuccessMessage: false,
  //             showCloseIcon: true
  //           }
  //         });

  //         errorDialogRef.afterClosed().subscribe(() => {
  //           // Optionally handle any action after closing the error dialog
  //           console.log('Error dialog closed');
  //         });
  //       }
  //     );
  //   }



  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }





  updateAutority() {
    let updateData = this.authorityForm.value;
    updateData.allocatingDep = updateData.allocatingDep?.trim?.() || updateData.allocatingDep;
    updateData.employeeId = updateData.employeeId?.trim?.() || updateData.employeeId;
    if (updateData.allocatingDep == '') {
      this.toastr.error('Please select department.', 'Error');
      return;
    }
     if(updateData.employeeId == ''){
      this.toastr.error('Please select employee.', 'Error');
      return;
    }

    if(updateData.allocatingDep == '' || updateData.employeeId == ''){
      this.toastr.error('Please select both department and employee.', 'Error' );
      return;
    }
    const formData = {
      "assetDepartmentName": updateData.allocatingDep,
      "userId": updateData.employeeId,
      "companyId": this.loggedInUserCompanyID,
    };

    const autorityListData = this.mainComponentData?.autorityListData;

    if (autorityListData?.length > 0) {
      const isDuplicate = autorityListData.some((empData: any) => {
        const isSameUser = empData.userId?.trim?.() === updateData.employeeId;
        const isSameDept = empData.assetDepartmentName?.trim?.() === updateData.allocatingDep;
        const isSameRecord = empData.assetAuthorityId === updateData.assetAuthorityId; // Unique ID match

        return isSameUser && isSameDept && !isSameRecord;
      });

      if (isDuplicate) {
        this.toastr.error('Duplicate entry not allowed', 'Error');
        return; // Stop update if duplicate found
      }
    }

    // Proceed with update if no duplicates
    this.httpService.callPutService(`${this.config.updateAssetAuthority}/${updateData.assetAuthorityId}`, formData).subscribe(
      (data: any) => {
        if (data) {
          this.toastr.success(data.message, 'Success' );
          this.dialogRef.close();
        }
      },
      (error: any) => {
        this.toastr.error(error.error.error || 'Duplicate Entries Not Allowed', 'Error');
      }
    );
  }

  cancelData() {
    this.dialogRef.close();
  }
}
